import React from "react";

import {
	MostPlayedTicketsAsideWidgets,
	QuickPlayAsideWidget,
	Results,
	Statistics,
	OneClickBetNotification,
	SideLiveWidget,
	WorldCup,
} from "@features/side-widgets";

import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";
import { MiniMyBets } from "@features/my-bets/desktop/mini-my-bets";
import { THEME_SETTINGS } from "@theme-settings";

import { BetSlip } from "@features/side-widgets/bet-slip";
import QuickBetWidget from "@features/quick-play/desktop/quick-bet/QuickBetWidget";
import MaintenanceNotice from "@features/maintenance/desktop/MaintenanceNotice";

export function AsideWidgets(props: { hideQuickBet?: boolean }) {
	return (
		<ErrorBoundaryWithPropagation
			componentName={"Desktop/AsideWidgets.tsx"}
		>
			<aside className="l--aside--right">
				<MaintenanceNotice />
				<OneClickBetNotification />
				<SideLiveWidget />
				<BetSlip />
				<MiniMyBets />
				{!props.hideQuickBet && <QuickBetWidget />}
				{THEME_SETTINGS.features.isQuickPlayEnabled && (
					<>{!props.hideQuickBet && <QuickPlayAsideWidget />}</>
				)}
				{props.hideQuickBet && <MostPlayedTicketsAsideWidgets />}
				<WorldCup />
				<Statistics />
				<Results />
			</aside>
		</ErrorBoundaryWithPropagation>
	);
}
